/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const ErrorIconCircle = (props) => (
  <SvgIcon
    style={{
      width: '32px',
      height: '32px',
    }}
    viewBox="0 0 32 32"
    version="1.1"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{props.title}</title>
    <circle cx="16" cy="16" r="16" fill="#D34343" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2222 9.09065C14.2222 8.0865 15.0181 7.27246 16 7.27246C16.9818 7.27246 17.7777 8.0865 17.7777 9.09065V16.3634C17.7777 17.3675 16.9818 18.1816 16 18.1816C15.0181 18.1816 14.2222 17.3675 14.2222 16.3634V9.09065Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2222 21.8179C14.2222 20.8137 15.0181 19.9997 16 19.9997C16.9818 19.9997 17.7777 20.8137 17.7777 21.8179C17.7777 22.8221 16.9818 23.6361 16 23.6361C15.0181 23.6361 14.2222 22.8221 14.2222 21.8179Z"
      fill="white"
    />
  </SvgIcon>
);

ErrorIconCircle.propTypes = {
  title: PropTypes.string,
};

ErrorIconCircle.defaultProps = {
  title: '',
};

export default ErrorIconCircle;
